<template>
    <v-container fluid style="margin-top: -12px;">
        <v-progress-linear indeterminate  v-if="isLoading"></v-progress-linear>
    <LineChartGenerator  v-if="!isLoading"
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
    </v-container>
  </template>
  
  <script> 
  import BaseModule from '../../../common/BaseModule.js'
  import ChartBaseModule from './ChartBaseModule.js'
  import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)
  export default {
    name: 'BarChart',
    mixins: [BaseModule, ChartBaseModule],
    components: {
      LineChartGenerator
    },
    mounted() {
        this.update();
    },
    methods: {

    },
    data() {
      return {
       
      }
    }
  }
  </script>